import { useTranslation } from 'react-i18next';

import FlexRow, { FlexRowProps } from './FlexRow';
import { FieldInfo } from './Dropdown';

export interface TabProps {
  field:			FieldInfo;
  active:			any;
  setActive:		(val: any) => any;
}

const Tab = (props: TabProps) => {
  const { t } = useTranslation();
  
  return (
  <FlexRow flex={0}
           className={[
             'whitespace-nowrap uppercase px-[16px] py-[8px] border-solid cursor-pointer',
             props.active == props.field.value
             ?	'border-b-2 border-b-[--Primetime-main]'
             :	'border-b-1 border-b-[--Lines]',
           ]}
           onClick={() => props.setActive(props.field.value)}>
    <span className={[
      props.active == props.field.value
      ?	'text-black'
      :	'text-[--Dark-Grey]',
      'r12'
    ].join(" ")}>
      { t(props.field.desc) }
    </span>
  </FlexRow>
  )
};

export interface TabsProps extends FlexRowProps {
  tabs:				FieldInfo[];
  active:			any;
  setActive:		(val: any) => any;
}

const Tabs = (tprops: TabsProps) => {
  const {tabs, active, flex, setActive, ...props} = tprops;
  
  const f = flex === undefined
  			?	0
  			:	flex;
  
  return (
  <FlexRow flex={f}
           {...props}>
  {tabs.map((field: FieldInfo, i: number) =>
    <Tab key={i}
         field={field}
         active={active}
         setActive={setActive} />
  )}
  </FlexRow>
  );
};

export default Tabs;
